<template>
  <a-form :model="detail" ref='ruleFormAd' class="m-t-20" :wrapper-col="{span:20}">
    <app-warp :title='detail.title ?detail.title:"扫码广告页"'>
      <template #app-content>
        <div class="pic_content" v-if="detail.type==1"
          :style="'background-image:url('+info.picdomain+detail.pic_source+')'"></div>
        <video :src="info.picdomain+detail.video_source" autoplay="autoplay" muted loop v-else></video>
        <!-- <div class="bar mint active" data-percent="100" data-skill="HTML5"></div> -->
      </template>
      <template #app-sider>
        <div class="moduleContent m-l-20" style="width:auto;">
          <a-form-item label="是否开启广告页" class='mb15' name='is_show_ad' :label-col="{span:4}">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="detail.is_show_ad" />
          </a-form-item>
          <div v-if='detail.is_show_ad'>
            <a-form-item label="页面标题" class='mb15' name='title' :label-col="{span:4}">
              <a-input v-model:value="detail.title" placeholder="请输入页面标题" style="width:250px" :maxlength='6'></a-input>
            </a-form-item>
            <a-form-item label="跳过时长" class='mb15' name='time' :label-col="{span:4}">
              <a-input-number v-model:value="detail.time" :min="1" placeholder="请输入跳过时长" style="width:150px"
                :maxlength='6'></a-input-number> 秒
            </a-form-item>
            <a-form-item label="显示类型" class='mb15' name='type' :label-col="{span:4}">
              <a-radio-group v-model:value="detail.type">
                <a-radio :value="1">图片</a-radio>
                <a-radio :value="2">视频</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="上传图片" class='mb15' name='pic_source' :label-col="{span:4}" v-if="detail.type==1"
              help="推荐尺寸750*1334">
              <material :groupType='1' :image="detail.pic_source" :max="1" v-on:handlechoose="(data)=>{
                  detail.pic_source=data}" v-on:handledel="delPic" />
              <a href="javascript:;" @click="detail.pic_source='/web_base_assets/scan/init.gif'">恢复默认图</a>
            </a-form-item>
            <a-form-item label="上传视频" class='mb15' name='video_cover' :label-col="{span:4}" v-if="detail.type==2">
              <material :groupType='2' :image="detail.video_cover" :max="1" v-on:handlechoose="(data)=>{
                  detail.video_source=data.file_name;detail.video_cover=data.video_image_name}"
                v-on:handledel="detail.video_source='';detail.video_cover=''" />
            </a-form-item>
          </div>
        </div>
      </template>
    </app-warp>
  </a-form>
</template>
<script>
  import { watchEffect, ref } from "@vue/runtime-core";
  import store from '@/store'
  export default {
    props: {
      ad_data: {
        type: Object || null,
        default() {
          return {};
        },
      }
    },
    setup(props, { emit }) {
      const detail = ref({
        is_show_ad: 0,
        type: 1,
        pic_source: "/web_base_assets/scan/init.gif",
        time: 2,
        video_source: "",
        video_image_name: '',
        video_cover: '',
        title: '扫码广告页'
      });
      watchEffect(()=>{
        if (Object.keys(props.ad_data).length) {
          detail.value = props.ad_data;
        }
      })
      const delPic = () => {
        detail.value.pic_source = ''
      }
      const submit = () => {
        if (!detail.value.pic_source) {
          detail.value.pic_source = '/web_base_assets/scan/init.gif'
        }
        emit("submit", detail.value);
        return detail.value;
      };
      return {
        detail,
        info: store.state.user.info,
        delPic,
        submit
      };
    },
  };
</script>

<style lang="less" scoped>
  .moduleContent {
    width: 285px;
    min-height: 600px;
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 15px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;
  }

  .pic_content {
    position: relative;
    height: 100%;
    background-position: center;
    background-size: cover;
  }

  video {
    width: 100%;
    height: 100%;
  }

  // .bar .mint{
  // background-color: #14c3a2;
  //     background-image: repeating-linear-gradient(
  // -45deg
  // , #14c3a2, #14c3a2 30px, #22e8c3 30px, #22e8c3 60px);
  //     background-size: 600px 100%;
  //     animation: barberpole 12s linear infinite;
  //     border-bottom: 0.2rem solid #0d7e68;
  // }
  // .bar:after{
  //     content: attr(data-percent) "%";
  //     display: block;
  //     position: absolute;
  //     top: 0;
  //     right: 0;
  //     height: 40px;
  //     padding: 10px;
  //     opacity: 0;
  //     transition: opacity 2s 0.6s;
  // }
</style>